module.exports = __webpack_public_path__ + "static/media/-_ProvidentFund.88be8d27.png";